<h2 class="step-title">{{ title }}</h2>
<h3>
  {{ subtitle }}
</h3>
<div class="field">
  <div [ngClass]="{'control': true, 'has-icons-left': isIconTest}">
    <input *ngIf = "!inputModeTest" class="input is-large email-step fontTest"
    [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && control.touched && control.errors, 'icon-style': isIconTest}"
    type="email" placeholder="Email" formControlName="email" #email (change)="snap()">
    <span class="icon is-small is-left" *ngIf="isIconTest">
      <i class="fas fa-envelope"></i>
    </span>

    <input *ngIf = "inputModeTest" inputmode="email" class="input is-large email-step fontTest"
    [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && control.touched && control.errors}"
    type="email" placeholder="Email" formControlName="email" #email (change)="snap()">
  </div>

  <div *ngIf="control.touched && control.errors" class="help is-danger has-text-left">
    <p *ngIf="control.errors.required">Email is required.</p>
    <p *ngIf="control.errors.email || control.errors.pattern">Invalid email address.</p>
  </div>
</div>

<button   class="button continue is-large has-shadow-small" (click)="submit()">
  {{ submitButtonText }}
<i class="fas fa-chevron-right"></i>
</button>
